import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getContactSettings, updateContactSettings } from '@/backend/services/contactSettings';
import type { ContactSettings } from '@/backend/services/contactSettings';

export function useContactSettings() {
  return useQuery({
    queryKey: ['contact-settings'],
    queryFn: getContactSettings,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateContactSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data, updatedBy }: { data: Partial<ContactSettings>; updatedBy: string }) =>
      updateContactSettings(data, updatedBy),
    onSuccess: (_, { data }) => {
      queryClient.setQueryData<ContactSettings>(['contact-settings'], (old) =>
        old ? { ...old, ...data } : (data as ContactSettings),
      );
      queryClient.invalidateQueries({ queryKey: ['contact-settings'] });
    },
  });
}
